var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElectricCar = function SvgElectricCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "electric_car_svg__a",
    width: 19,
    height: 19,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h19v19H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#electric_car_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M4.448 11.48v.745q0 .349-.244.593a.8.8 0 0 1-.594.245.8.8 0 0 1-.593-.245.8.8 0 0 1-.244-.593v-5.83L4.39 1.78a.8.8 0 0 1 .325-.433.9.9 0 0 1 .525-.16h8.556q.277 0 .504.163a.84.84 0 0 1 .315.43l1.617 4.613v5.831q0 .349-.245.593a.8.8 0 0 1-.594.245.8.8 0 0 1-.592-.245.8.8 0 0 1-.244-.593v-.746zm-.006-6.273h10.121l-.999-2.832H5.441zm1.47 4.171q.431 0 .732-.302.3-.303.3-.735t-.302-.733q-.302-.3-.734-.3t-.733.302-.3.735.302.733q.303.3.734.3m7.185 0q.433 0 .733-.302.3-.303.3-.735t-.302-.733q-.302-.3-.734-.3t-.733.302-.3.735.302.733q.302.3.734.3m-2.856 8.693-4.4-2.207h2.923v-1.477l4.4 2.207h-2.923zm-6.28-7.78h11.083V6.395H3.961z"
  }))));
};
export default SvgElectricCar;